export * from './dvir.dto';
export * from './truck-document.dto';
export * from './truck-parameters.dto';
export * from './vehicle-abs.dto';
export * from './vehicle-bcm.dto';
export * from './vehicle-document.dto';
export * from './vehicle-ecu.dto';
export * from './vehicle-environment.dto';
export * from './vehicle-location.dto';
export * from './vehicle-metrics-response.dto';
export * from './vehicle-parameters.dto';
export * from './vehicle-tpms.dto';
export * from './vehicle-tracking-response.dto';
export * from './vehicle.dto';
export * from './tracking.dto';
